/**
 * Created by qiuru.yan on 2018/4/12.
 */

import uri from './uri';
import ajax from './ajax.jquery';
let source = uri.getQuery('source');
var account = null;

function doumengInit() {
  if(Array.isArray(account)){
    let doumeng = account.some(item=>{
      if(source >= item.lt && source<= item.gt){
        return true
      }else {
        return false
      }
    })
    if (doumeng) {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://interaction.bayimob.com/static/hdggstatistics.js';
      let s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(script, s);
    }
  }
}
export function doumengPush() {
  if(window._ai_analysis){
    _ai_analysis(['trackEvent', 'register', 'button', 'click']);
  }
};

export function dminit(url) {
  if (!source) {
    return;
  }
  ajax.get(url).then((response)=>{
    let json = response
    if(json && json.account){
      account = json.account;
      doumengInit();
    }
  })
}
export default {dminit, doumengPush};



// WEBPACK FOOTER //
// ./src/component/common/doumeng.js